import { useTranslation } from 'react-i18next'
import { EHumanReviewRequestProblem } from './human-review-requests.type'
import { useMemo } from 'react'

export const useProblemLabels = (): Record<EHumanReviewRequestProblem, string> => {
  const { t } = useTranslation()
  return useMemo(
    () => ({
      [EHumanReviewRequestProblem.SMS_NOT_RECEIVED]: t(
        'pages.dashboard.human-review-requests.problems.labels.sms-not-received',
      ),
      [EHumanReviewRequestProblem.MISSING_DOCUMENT]: t(
        'pages.dashboard.human-review-requests.problems.labels.missing-document',
      ),
      [EHumanReviewRequestProblem.CONVOCATION_DATE_CHANGED]: t(
        'pages.dashboard.human-review-requests.problems.labels.convocation-date-changed',
      ),
      [EHumanReviewRequestProblem.NO_RESPONSE]: t(
        'pages.dashboard.human-review-requests.problems.labels.no-response',
      ),
      [EHumanReviewRequestProblem.INCOMPLETE_QUESTIONNAIRE]: t(
        'pages.dashboard.human-review-requests.problems.labels.incomplete-questionnaire',
      ),
      [EHumanReviewRequestProblem.DECLARED_COMPLICATION]: t(
        'pages.dashboard.human-review-requests.problems.labels.declared-complication',
      ),
      [EHumanReviewRequestProblem.APPOINTMENT_CANCELLED]: t(
        'pages.dashboard.human-review-requests.problems.labels.appointment-cancelled',
      ),
      [EHumanReviewRequestProblem.APPOINTMENT_RESCHEDULE_REQUESTED]: t(
        'pages.dashboard.human-review-requests.problems.labels.appointment-reschedule-requested',
      ),
      [EHumanReviewRequestProblem.MISSING_DISCHARGE_COMPANION]: t(
        'pages.dashboard.human-review-requests.problems.labels.missing-discharge-companion',
      ),
      [EHumanReviewRequestProblem.UNKNOWN]: t(
        'pages.dashboard.human-review-requests.problems.labels.unknown',
      ),
    }),
    [t],
  )
}
